import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";

const ProviderFilterPopup = ({ isOpen, onClose, providerData, onProviderSelect }) => {
  
  const [selectedProvider, setSelectedProvider] = useState([]); // Track selected provider

  // Handle Provider click (only for visual selection until apply is clicked)
  const handleProviderClick = (providername) => {
    setSelectedProvider((prevSelectedProviders) => {
      if (prevSelectedProviders.includes(providername)) {
        return prevSelectedProviders.filter((provider) => provider !== providername); // Remove from the array
      } else {
        return [...prevSelectedProviders, providername]; // Add to the array
      }
    });
  };
  

  // Handle Apply Filters button click
  const handleApplyFilters = () => {
    if (selectedProvider) {
      onProviderSelect(selectedProvider); // Call the parent function to update the provider filter
    }
    onClose(); // Close the popup after applying the filter
  };

  const handleClearFilters = () => {
    setSelectedProvider([]); // Reset selected provider to null
    onProviderSelect([]); // Clear the filter in the parent component
    onClose(); 
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        {/* Popup Box */}
        <div className="relative flex flex-col gap-2 w-[386px] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
          <button
            className="absolute right-[3%] text-gray-500 hover:text-gray-700 text-[30px]"
            onClick={onClose}
          >
            <CloseIcon style={{ color: 'black', width: '15px' }} />
          </button>
          <div className="p-2 border-b pb-4">
            <div className="w-full flex items-center justify-between mt-2">
              {/* Title */}
              <span className="ml-2  font-inter text-[#1D2951] text-[16px] font-semibold text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Filter by Provider
              </span>
            </div>
          </div>

          <div className="flex ml-3 flex-wrap">
  {[...new Set(providerData.map(x => x.linked_provider))] // Get unique linked_provider values
    .map((provider, index) => {
      // Define the base button classes
      let buttonClass = "inline-block bg-[#F3F4F6] border-[#ccc] flex-wrap rounded-full py-2 px-3 text-[11px] w-[auto] font-inter text-[black] border-[1.5px] border-gray-200 mr-2 mb-2";

      // Add a selected class for the selected provider
      const selectedClass = selectedProvider.includes(provider)? "bg-[#FF5733] text-white  " : ""; // Changed to a new color

      return (
        <button
          key={index}
          onClick={() => handleProviderClick(provider)}
          className={`${buttonClass} ${selectedClass}`}
        >
          {provider} {/* Button text */}
        </button>
      );
    })
  }
</div>

          {/* Apply Filters Button */}
          <div className="w-full flex justify-between gap-6 mb-1 mt-3">
            {/* Clear All Filters Button */}
            <button
              onClick={handleClearFilters}
              className="rounded py-2 px-4 text-[13px] font-poppins px-2 transition duration-300 ease-in-out border-2 font-Font1 text-[black]"
            >
              Clear All
            </button>

            <button
              onClick={handleApplyFilters}
              className={`rounded py-2 px-4 text-[12px] font-inter px-2 transition duration-300 ease-in-out bg-[black] text-[#FFFFFF]`}
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ProviderFilterPopup;
